import img1 from "../BestSellingProducts/SellingImages/coat.png";
import img2 from "../BestSellingProducts/SellingImages/bag.png";
import img3 from "../BestSellingProducts/SellingImages/speaker.png";
import img4 from "../BestSellingProducts/SellingImages/desk.png";

export const DataSelling = [
  {
    id: 14,
    img: img1,
    title: "The north coat",
    currentPrice: 260,
    actualPrice: 360,
    starRate: 5,
    reviews: 65,
  },
  {
    id: 15,
    img: img2,
    title: "Gucci duffle bag",
    currentPrice: 1160,
    actualPrice: 960,
    starRate: 4.4,
    reviews: 65,
  },
  {
    id:16 ,
    img: img3,
    title: "RGB liquid CPU Cooler",
    categoryItem:"electronic",
    currentPrice: 170,
    actualPrice: 160,
    starRate: 4.4,
    reviews: 65,
  },
  {
    id:17 ,
    img: img4,
    title: "Small BookSelf",
    currentPrice: null,
    actualPrice: 360,
    starRate: 5,
    reviews: 65,
  },
];
